import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './styles.module.css';
import Button from '../../../../shared/ui/button/button';
import { forgotPasswordRequest } from '../../api/index';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import ForgotPasswordImg from '../../../../shared/assets/icons/ForgotPassword.png';
import { useIntl } from 'react-intl';
import {
	formatErrorDetail,
	isNetworkError,
} from '../../../../shared/api/apiError';

export const ForgotPassword = () => {
	const intl = useIntl();
	const [errorMessage, setErrorMessage] = useState('');
	const navigate = useNavigate();
	const formik = useFormik({
		initialValues: {
			email: '',
		},
		validationSchema: Yup.object({
			email: Yup.string()
				.email(intl.formatMessage({ id: 'ForgotPasswordValidationId1' }))
				.matches(
					/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
					intl.formatMessage({ id: 'ForgotPasswordValidationId2' }),
				)
				.required(intl.formatMessage({ id: 'ForgotPasswordValidationId3' })),
		}),
		onSubmit: values => {
			alert(JSON.stringify(values, null, 2));
		},
	});
	const handleForGotPassword = async () => {
		const userData = {
			email: formik.values.email,
		};

		const emptyFields = Object.entries(userData)
			.filter(
				([key, value]) => value === null || value === undefined || value === '',
			)
			.map(([key]) => key);

		if (emptyFields.length > 0) {
			// setIsToastOpen(true);
			return;
		}
		formik.resetForm();
		const forgotPassword = await forgotPasswordRequest(userData);

		if (forgotPassword?.status === 200) {
			navigate(
				`/verification-forgot-password?email=${encodeURIComponent(formik.values.email)}`,
			);
			return;
		}

		// A network failure carries no `response` at all - reading `detail` off it
		// threw inside the handler and took the page down instead of showing the
		// user anything.
		if (isNetworkError(forgotPassword)) {
			setErrorMessage(intl.formatMessage({ id: 'SignInValidationId5' }));
			return;
		}

		setErrorMessage(
			formatErrorDetail(
				forgotPassword?.response?.data?.detail,
				intl.formatMessage({ id: 'SignInValidationId4' }),
			),
		);
	};
	return (
		<div className={styles.container}>
			<div className={styles.card}>
				<div className={styles.iconContainer}>
					<img src={ForgotPasswordImg} alt='' />
				</div>

				<h1 className={styles.title}>
					{intl.formatMessage({ id: 'ForgotPasswordId1' })}
				</h1>

				<p className={styles.description}>
					{intl.formatMessage({ id: 'ForgotPasswordId2' })}
				</p>

				<div className={styles.form}>
					<label htmlFor='email' className={styles.label}>
						{intl.formatMessage({ id: 'ForgotPasswordId3' })}
					</label>
					<input
						id='email'
						name='email'
						type='email'
						value={formik.values.email}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						placeholder={intl.formatMessage({ id: 'ForgotPasswordId4' })}
						className={styles.input}
						required
					/>
					{errorMessage && (
						<p className={styles.errorMessage}>{errorMessage}</p>
					)}
					<Button onClick={handleForGotPassword} fullWidth>
						{intl.formatMessage({ id: 'ForgotPasswordId5' })}
					</Button>
				</div>

				<div className={styles.footer}>
					<Link to='/sign-in' className={styles.backLink}>
						{intl.formatMessage({ id: 'ForgotPasswordId9' })}
					</Link>
					<span className={styles.footerDot} aria-hidden='true' />
					<Link to='/sign-up' className={styles.signupLink}>
						{intl.formatMessage({ id: 'ForgotPasswordId8' })}
					</Link>
				</div>
			</div>
		</div>
	);
};
